export const PROFICIENCY_OPTIONS = [
    {
      value: "BEGINNER",
      label: "common_ns:COMMON_ITEMS.LANGUAGE_PROFICIENCY.BEGINNER",
    },
    {
      value: "INTERMEDIATE",
      label: "common_ns:COMMON_ITEMS.LANGUAGE_PROFICIENCY.INTERMEDIATE",
    },
    {
      value: "ADVANCED",
      label: "common_ns:COMMON_ITEMS.LANGUAGE_PROFICIENCY.ADVANCED",
    },
];


export const DEGREE_OPTIONS = [
  {
    value: "BACHELOR",
    label: "common_ns:COMMON_ITEMS.TRAINER_DEGREE.BACHELOR",
  },
  { value: "MASTER", label: "common_ns:COMMON_ITEMS.TRAINER_DEGREE.MASTER" },
  { value: "PHD", label: "common_ns:COMMON_ITEMS.TRAINER_DEGREE.PHD" },
  { value: "OTHER", label: "common_ns:COMMON_ITEMS.TRAINER_DEGREE.OTHER" },
];

export const GRADUATION_STATUS_OPTIONS = [
  {
    value: "NOT_GRADUATED",
    label: "common_ns:COMMON_ITEMS.TRAINER_GRADUATION_STATUS.NOT_GRADUATED",
  },
  {
    value: "GRADUATED",
    label: "common_ns:COMMON_ITEMS.TRAINER_GRADUATION_STATUS.GRADUATED",
  },
  {
    value: "IN_PROGRESS",
    label: "common_ns:COMMON_ITEMS.TRAINER_GRADUATION_STATUS.IN_PROGRESS",
  },
];

export const STATUS = {
  Published: "PUBLISHED",
  Unpublished: "UNPUBLISHED",
  Draft: "DRAFT",
  Rejected: "REJECTED",
  Deactivated: "DEACTIVATED",
  WaitingForApproval: "WAITING_FOR_APPROVAL",
};

export const TAG_BREAKPOINTS = {
  MOBILE: { maxWidth: 768, items: 3 },
  TABLET: { maxWidth: 1024, items: 6 },
  DESKTOP: { items: 9 }
};